import React from "react";
import "./Privacy.css";

function PrivacyPolicy() {
  return (
    <div 
    className="legal-container"
    onCopy={(e) => e.preventDefault()}       
    onCut={(e) => e.preventDefault()}        
    onPaste={(e) => e.preventDefault()}     
    onContextMenu={(e) => e.preventDefault()} 
    style={{ userSelect: "none" }}  
    >
      <h1 className="legal-title">Privacy Policy</h1>

      <p><strong>PRIVACY POLICY FOR Creora Developers PVT LTD</strong></p>

      <p>
        At Creora Developers Pvt. Ltd, accessible via{" "}
        <a href="https://www.creoradevelopers.com" target="_blank" rel="noreferrer">
          https://www.creoradevelopers.com
        </a>
        , one of our main priorities is the privacy of our visitors. This Privacy Policy
        document details the types of information that is collected and recorded by Creora and how we use it.
      </p>

      <p>
        If you have additional questions or require more information about our Privacy Policy,
        do not hesitate to contact us.
      </p>

      <p>
        This Privacy Policy applies only to our online activities and is valid for visitors to our website
        with regards to the information that they share to and/or collect from Creora Solutions.
        This policy is not applicable to any information collected offline or via channels other than this website.
      </p>

      <h2>Consent</h2>
      <p>
        By using our website, you hereby give your consent to our Privacy Policy and agree to its terms.
      </p>

      <h2>Information We Collect</h2>
      <p>
        The personal information that you are asked to provide, and the reasons why you are asked to provide it,
        will be made clear to you at the point we ask you to provide such information.
      </p>
      <p>
        If you contact us directly, we may receive additional information about you such as your name,
        email address, phone number, the contents of the message and/or attachments you may send us,
        and any other information you may choose to provide.
      </p>
      <p>
        When you register for an Account, we may ask for your contact information, including items such as
        name, company name, address, email address, and telephone number.
      </p>

      <h2>How We Use Your Information</h2>
      <ol>
        <li>Provide for, operate, and maintain our website</li>
        <li>Improve, personalize, and expand our website</li>
        <li>Understand and analyze how you use our website</li>
        <li>Develop new products, services, features, and functionality</li>
        <li>
          Communicate with you, either directly or through one of our partners,
          including for customer service, to provide you with updates and other information
          relating to the website, and for marketing and promotional purposes
        </li>
        <li>Send you emails</li>
        <li>Find and prevent fraudulent activity</li>
      </ol>

      <h2>Log Files</h2>
      <p>
        Creora Solutions follows a standard procedure of using log files. These files log visitors when they visit websites.
        All hosting companies do this as part of hosting services’ analytics. The information collected by log files include
        internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages,
        and possibly the number of clicks. These are not linked to any information that is personally identifiable.
        The purpose of the information is for analyzing trends, administering the site, tracking users’ movement on the website,
        and gathering demographic information.
      </p>

      <h2>Cookies and Web Beacons</h2>
      <p>
        Like any other website, Creora Solutions uses ‘cookies’. These cookies are used to store information including visitors’
        preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the
        users’ experience by customizing our web page content based on visitors’ browser type and/or other information.
      </p>
      <p>For more general information on cookies, please read “What Are Cookies”.</p>

      <h2>Our Advertising Partners</h2>
      <p>
        Some of advertisers on our site may use cookies and web beacons. Each of our advertising partners has their own Privacy Policy
        for their policies on user data. For easier access, we hyperlink to their Privacy Policies below.
      </p>
      <ol>
        <li>
          Google:{" "}
          <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noreferrer">
            https://policies.google.com/technologies/ads
          </a>
        </li>
      </ol>

      <h2>Advertising Partners Privacy Policies</h2>
      <p>
        You may consult this list to find the Privacy Policy for each of the advertising partners of Creora Solutions.
      </p>
      <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on the website of Creora solutions, which are sent to the third party. They automatically receive your IP address when this transfer occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>
<p>Note that Creora solutions has no access to or control over these cookies that are used by third-party advertisers.
</p>

<h2>THIRD PARTY PRIVACY POLICIES</h2>

<p>The Privacy Policy of Creora Solutions does not apply to other advertisers or websites. We advise you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>

<p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers check the websites of the respective websites.</p>

      <h2>CCPA Privacy Rights (Do Not Sell My Personal Information)</h2>
      <p>Under the CCPA, among other rights, California consumers have the right to:</p>
      <ol>
        <li>
          Request a business, that collects a consumer’s personal data, to disclose the categories
          and specific pieces of personal data the business has collected about consumers.
        </li>
        <li>Request a business to delete any personal data about the consumer that a business has collected.</li>
        <li>Request a business that sells consumer’s personal data, not to do so.</li>
      </ol>

      <h2>GDPR Data Protection Rights</h2>
      <p>
        We would like to make sure you are fully aware of all of your data protection rights.
        Every user is entitled to the following:
      </p>
      <ol>
        <li>The right to access – You have the right to request copies of your personal data.</li>
        <li>The right to rectification – You have the right to request corrections to inaccurate information.</li>
        <li>The right to erasure – You have the right to request that we erase your personal data, under certain circumstances.</li>
        <li>The right to restrict processing – You have the right to request restrictions, under certain circumstances.</li>
        <li>The right to object to processing – You have the right to object, under certain circumstances.</li>
        <li>The right to data portability – You can request we transfer the data we have collected to another organization, or directly to you.</li>
      </ol>
      <p>
        If you exercise any of these rights by making a request, we’ll respond to you within a month.
      </p>

      <h2>Children’s Information</h2>
      <p>
        Another part of our priority is adding protection for children while using the internet.
        We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.
      </p>
      <p>
        Creora Solutions does not knowingly collect any Personal Identifiable Information from children under the age of 13.
        If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately
        and we will do our best efforts to promptly remove such information from our records.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
